import { type Dispatch, type SetStateAction, useId } from 'react'
import { CIRCLES, type OptionCircle } from 'shared/search-adapters'
import { ListSelect } from 'shared/ui'

import css from './Filters.module.css'
export function Connection({
	setter,
	value
}: {
	setter: Dispatch<SetStateAction<OptionCircle[]>>
	value: OptionCircle[]
}) {
	const id = useId()

	return (
		<div className={css.set}>
			<label className={css.label} htmlFor={id}>
				Connection
			</label>
			<ListSelect
				getOptionLabel={option => option.label}
				// getOptionValue={option => option.value}
				getTag={option => option.label}
				inputId={id}
				isMulti
				onChange={values => setter(Array.from(values))}
				options={CIRCLES}
				placeholder='Connection'
				setter={setter}
				value={value}
			/>
		</div>
	)
}
